import { create } from 'zustand';

// counterItems — what a job just HANDED you, set on its room's counter.
//
// Khari, 2026-10-30: "another type of job: grocer/cashier. We have a corner
// market with a job for an artist to work the cash register." And, about job
// tools: "If this is a new tool call, we should make it generic enough to handle
// more items like this."
//
// The cashier's ring_up (API GroceryService, on the shared counter seam
// CounterItems) comes back as `out.purchase = { items }`; worldJob applyRoleOut
// puts it here, for a room that has a `counter` spot (rooms.js). Generic on
// purpose: any job whose tool hands over a few named things can land them on
// its counter through this, with no new store and no new component.
//
//   phase  'ringing' (a beat of scanning) → 'bagged' (on the counter) → gone
//
// A STORE OF ITS OWN, not a worldStore slice: three readers (worldJob, the
// counter dialog, the 3D counter) and nothing else needs it. The TIMERS LIVE
// HERE, not in the 3D component, so a bag always goes after its minute even if
// nothing in the room is drawing it (and the dialog's "on the counter" line goes
// with it). Leaving the room clears it sooner (CounterItems unmount).
export const RING_MS = 2500;      // scanning, item by item
export const SHOW_MS = 60000;     // then it is gone: taken
const MAX_ITEMS = 8;              // the API's own cap (GroceryService)

export const useCounterItems = create(() => ({ current: null }));

let timers = [];
const stopTimers = () => { timers.forEach(clearTimeout); timers = []; };

/** Something was handed over at `zone`'s counter. Replaces whatever was there. */
export function placeCounterItems({ items, zone, roleKey = null }) {
  const list = (Array.isArray(items) ? items : [])
    .filter((v) => typeof v === 'string' || typeof v === 'number')
    .map((v) => String(v).trim().slice(0, 40))
    .filter(Boolean)
    .slice(0, MAX_ITEMS);
  if (!list.length || !zone) return;
  stopTimers();
  const id = Date.now();
  useCounterItems.setState({ current: { id, items: list, zone, roleKey, at: id, phase: 'ringing' } });
  timers.push(setTimeout(() => {
    const c = useCounterItems.getState().current;
    if (c?.id === id) useCounterItems.setState({ current: { ...c, phase: 'bagged', baggedAt: Date.now() } });
  }, RING_MS));
  timers.push(setTimeout(() => clearCounterItems(zone, id), RING_MS + SHOW_MS));
}

/** Take it away — only `zone`'s, and only purchase `id` when given (so a stale timer cannot clear a newer bag). */
export function clearCounterItems(zone = null, id = null) {
  const c = useCounterItems.getState().current;
  if (!c || (zone && c.zone !== zone) || (id && c.id !== id)) return;
  stopTimers();
  useCounterItems.setState({ current: null });
}
